import "./footerdesktop.css";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import facebookIcon from "@/assets/facebook.png";
import instagramIcon from "@/assets/instagram.png";
import whatsappIcon from "@/assets/whatsapp.png";
import anpcSalSvg from "@/components/common/footer/anpc-sal.svg";
import anpcSolSvg from "@/components/common/footer/anpc-sol.svg";
import gdprEuSvg from "@/components/common/footer/gdpr.eu.svg";

interface FooterProps {
  logo: string;
  greenDot: string;
  NextButton: React.FC<any>;
  handleScrollToTop: () => void;
}

const FooterDesktop: React.FC<FooterProps> = ({
  logo,
  greenDot,
  NextButton,
  handleScrollToTop,
}) => {
  return (
    <Container className="footer-container">
      <div className="footer-base">
        <img className="footer-base-img" src="/footer/footer-base.webp" alt="" />
        <Col className="green-dots">
          <Row>
            <img className="green-dot" src={greenDot} alt="" />
          </Row>
          <Row>
            <img className="green-dot" src={greenDot} alt="" />
          </Row>
          <Row>
            <img className="green-dot" src={greenDot} alt="" />
          </Row>
        </Col>
        <NextButton
          onClick={handleScrollToTop}
          className="footer-next"
        />
        <div className="footer">
          <div className="footer-row body">
            <Row className="align-items-start">
              <Col lg={5} className="footer-col">
                <Row>
                  <div>
                    <img className="logo-footer" src={logo} alt="Pixado Logo" />
                  </div>
                </Row>
                <Row>
                  <p className="footer-text body">
                    Pixado este agenția ta de încredere pentru soluții creative de branding, web design & development, online marketing, reclame video și CGI/VFX. Cu un ochi atent pentru detalii și o echipă pasionată, transformăm ideile în realitate, livrând mereu rezultate memorabile.
                  </p>
                </Row>
                
                {/* Social Media Section - Proper Spacing */}
                <Row>
                  <Col xs={12}>
                    <div className="footer-social-section">
                      <div className="footer-social-text body">Hai cu noi pe social media!</div>
                      <div className="footer-social-icons-container">
                        <a href="https://www.facebook.com/pixadoagency" target="_blank" rel="noopener noreferrer">
                          <img src={facebookIcon} className="contact-dot" alt="Facebook" />
                        </a>
                        <a href="https://www.instagram.com/pixadoagency/" target="_blank" rel="noopener noreferrer">
                          <img src={instagramIcon} className="contact-dot" alt="Instagram" />
                        </a>
                        <a href="https://wa.me/40745371620" target="_blank" rel="noopener noreferrer">
                          <img src={whatsappIcon} className="contact-dot" alt="WhatsApp" />
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={2} className="footer-col">
                <div className="footer-title title-4">Linkuri Rapide</div>

                <div className="footer-option footer-link-item">
                  <Link to="/servicii/web-design" className="back-link">
                    Web Design
                  </Link>
                </div>

                <div className="footer-option footer-link-item">
                  <Link to="/servicii/e-commerce" className="back-link">
                    E-commerce
                  </Link>
                </div>
                <div className="footer-option footer-link-item">
                  <Link to="/servicii/branding" className="back-link">
                    Branding
                  </Link>
                </div>
                <div className="footer-option footer-link-item">
                  <Link to="/servicii/online-marketing" className="back-link">
                    Online Marketing
                  </Link>
                </div>
              </Col>
              <Col lg={2} className="footer-col">
                <div className="footer-title title-4">Linkuri Utile</div>
                <div className="footer-svg-container">
                  <div className="footer-svg-item">
                    <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">
                      <img 
                        src={anpcSalSvg} 
                        alt="ANPC SAL" 
                        className="footer-svg"
                      />
                    </a>
                  </div>
                  <div className="footer-svg-item">
                    <a href="https://consumer-redress.ec.europa.eu/index_ro" target="_blank" rel="noopener noreferrer">
                      <img 
                        src={anpcSolSvg} 
                        alt="ANPC SOL" 
                        className="footer-svg"
                      />
                    </a>
                  </div>
                  <div className="footer-svg-item">
                    <a href="https://gdpr.eu/" target="_blank" rel="noopener noreferrer">
                      <img 
                        src={gdprEuSvg} 
                        alt="GDPR EU" 
                        className="footer-svg"
                      />
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={3} className="footer-col">
                <div className="footer-title title-4">Contact</div>
                <Row>Timișoara</Row>
                <Row>0745371620</Row>
                <Row>contact@pixado.ro</Row>
              </Col>
            </Row>
          </div>
          <div className="footer-row-center title-1">
            <Row>AICI PENTRU TINE</Row>
          </div>
          <div className="footer-row-bottom body">
            <Row>
              <Col lg={7}>
                <Row>
                  <Col lg={6}>website aflat in construcție</Col>
                  <Col lg={6}>© 2026 pixado agency</Col>
                </Row>
              </Col>
              <Col lg={5}>
                <div className="footer-bottom-legal">
                 <Link to="/politica-confidentialitate" className="back-link footer-bottom-link split-lines" onClick={handleScrollToTop}>
                   Politica de confidențialitate
                 </Link>
                 <Link to="/termeni-conditii" className="back-link footer-bottom-link" onClick={handleScrollToTop}>
                   Termeni și condiții
                 </Link>
                 <Link to="/politica-cookies" className="back-link footer-bottom-link" onClick={handleScrollToTop}>
                   Politica de Cookies
                 </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FooterDesktop;